import * as React from 'react';
import { ERentTime } from '../../../../../../../json_query';
import { InlineParam } from '../../../markup';
import { DropdownField, IDropdownValue } from '../../../components/dropdownField';

export interface IRentTimeProps {
  rentTime: ERentTime;
  onRentTimeChanged(value: ERentTime): void;
}

const RENT_TIME_PERIODS: IDropdownValue[] = [
  { value: ERentTime.NotDaily, label: 'Любой' },
  { value: ERentTime.FromYear, label: 'От года' },
  { value: ERentTime.FewMonths, label: 'На несколько месяцев' },
];

export const RentTimeComponent: React.StatelessComponent<IRentTimeProps> = props => (
  <InlineParam>
    <InlineParam>
      <DropdownField value={props.rentTime} onValueChange={props.onRentTimeChanged} values={RENT_TIME_PERIODS} />
    </InlineParam>
  </InlineParam>
);
